import React, { Component } from 'react';
import NavComponent from './Components/NavComponent'
import LandingComponent from './Components/LandingComponent'
import LoginComponent from './Components/LoginComponent'
import {Switch,Route} from 'react-router-dom'
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
	 <NavComponent/>
	 <Switch>
	  <Route exact path="/" component={LandingComponent}/>
	  <Route path="/login" component={LoginComponent}/>
	 </Switch>
      </div>
    )
  }
}

export default App;
